import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { VehicleApiService } from '../../api/vehicle-api.service';
import { actions } from './search-abo.actions';

@Injectable()
export class SearchAboEffects {
    private readonly actions$ = inject(Actions);
    private readonly api = inject(VehicleApiService);

    submitSearchAboForm$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.submitSearchAboForm),
            switchMap(({ data }) =>
                from(this.api.addSearchAbo(data)).pipe(
                    map(() => actions.submitSearchAboSuccess()),
                    catchError(() => of(actions.submitSearchAboError())),
                ),
            ),
        );
    });

    doiSearchAbo$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.dOISearchAbo),
            switchMap(({ guid }) =>
                from(this.api.doiSearchAbo(guid)).pipe(
                    map(() => actions.dOISearchAboSuccess()),
                    catchError(() => of(actions.dOISearchAboError())),
                ),
            ),
        );
    });

    cancelSearchAbo$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.cancelSearchAbo),
            switchMap(({ guid }) =>
                from(this.api.cancelSearchAbo(guid)).pipe(
                    map(() => actions.cancelSearchAboSuccess()),
                    catchError(() => of(actions.cancelSearchAboError())),
                ),
            ),
        );
    });
}
